import { Skeleton } from "antd";

const Loading: React.FC = () => (
  <Skeleton
    style={{
      padding: "24px",
      height: "60vh",
      borderTop:
        "var(--ant-line-width) var(--ant-line-type) var(--ant-color-border-secondary)",
    }}
    active
  />
);

export default Loading;
